// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609220904/js/" + chunkId + "." + {"44":"b2652ca6","225":"a419bc60","481":"9d386d3b","486":"34819a1e","770":"6302383d"}[chunkId] + ".0.36318621814739027.chunk.js";
};